import { render } from "./MyApp.vue?vue&type=template&id=36f68206&scoped=true"
import script from "./MyApp.vue?vue&type=script&lang=js"
export * from "./MyApp.vue?vue&type=script&lang=js"

import "./MyApp.vue?vue&type=style&index=0&id=36f68206&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f68206"]])

export default __exports__